module.exports = __webpack_public_path__ + "img/banner_placeholder.5256b61.png";